import { useEffect, useState } from "react";
import { EditableObject } from "../bean/EditableObject";
import logo_close from "../assets/close-check.png";
import ListSelector from "./ListSelector";
import AuthServices from "../services/AuthServices";
import ImportedObjectServices from "../services/ImportedObjectServices";
import reservationServices from "../services/ReservationServices";
import "../styles/ObjectEditor.css";

function ObjectEditor({ object, onCancel, onSave, readonly = false, isDaataRegistering = false, onReserveByOwner,p_setLightboxImg }) {
  const [localObj, setLocalObj] = useState(new EditableObject(object));
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  const [completeMsg, setCompleteMsg] = useState("");
  const [showReserver, setShowReserver] = useState(false);
  const [reserverInfo, setReserverInfo] = useState(null);
  const [isLoadingReserver, setIsLoadingReserver] = useState(false);
  const [reserverError, setReserverError] = useState("");

  useEffect(() => {
    if (!object) setLocalObj(new EditableObject());
    else setLocalObj(new EditableObject(object));
  }, [object]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalObj((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave && onSave(localObj);
  };

  const handleReserve = () => setShowConfirmModal(true);
  const confirmReservation = () => {
    setShowConfirmModal(false);
    onReserveByOwner && onReserveByOwner();
  };

  const chooseImage = (imp) => {
    if (imp?.image) return imp.image;
    if (Array.isArray(imp?.imageList)) {
      const first = imp.imageList.find(Boolean);
      if (first) return first;
    }
    return undefined;
  };

  const handleAutoComplete = async () => {
    if (!localObj?.url) {
      setCompleteMsg("Renseignez l'URL avant de completer.");
      return;
    }
    setIsCompleting(true);
    setCompleteMsg("");
    try {
      const imp = await ImportedObjectServices.fetchObjectFromUrl(localObj.url);
      if (!imp) {
        setCompleteMsg("Aucune information trouvee.");
        return;
      }
      const updates = {};
      const fill = (key, value) => {
        const cur = localObj[key];
        if ((cur === undefined || cur === null || cur === "") && value !== undefined && value !== null && value !== "") {
          updates[key] = value;
        }
      };
      fill("title", imp.title || imp.shortTitle);
      fill("description", imp.description);
      fill("imagelink", chooseImage(imp));
      fill("price", imp.price);
      fill("currency", imp.currency);
      fill("site", imp.site);
      fill("url", imp.url);

      if (Object.keys(updates).length > 0) {
        setLocalObj((prev) => ({ ...prev, ...updates }));
        setCompleteMsg("Champs completes.");
      } else {
        setCompleteMsg("Aucune info trouvée pour compléter.");
      }
    } catch (e) {
      console.error(e);
      setCompleteMsg("Erreur pendant la recuperation.");
    } finally {
      setIsCompleting(false);
    }
  };

  const isEmptyField = (v) => v === undefined || v === null || (typeof v === "string" && v.trim() === "");
  const hasEmptyFields = ["title", "description", "imagelink", "price", "site", "url"].some((k) =>
    isEmptyField(localObj?.[k])
  );

  const isReserved = localObj && localObj.reservationid != null;

  const handleShowReserver = async () => {
    if (!isReserved) return;
    const togglingTo = !showReserver;
    setShowReserver(togglingTo);
    if (togglingTo && !reserverInfo) {
      try {
        setIsLoadingReserver(true);
        setReserverError("");
        const key = AuthServices.getConnectedKey() || Date.now();
        const info = await reservationServices.getReservationInfo(key, localObj.reservationid);
        setReserverInfo(info);
      } catch (e) {
        setReserverError("Impossible de récupérer le réservant.");
      } finally {
        setIsLoadingReserver(false);
      }
    }
  };

  return (
    <div className="ui-overlay">
      <div className="ui-modal">
        {showConfirmModal && (
          <div className="ui-overlay">
            <div className="ui-modal">
                            <h3>Confirmer la réservation</h3>
                            <p>Êtes-vous sûr de vouloir marquer ce produit comme réservé ?</p>
                            <p>Les personnes à qui vous partagez vos listes peuvent réserver eux même les produits.</p>
              <div className="ui-buttons">
                <button onClick={() => setShowConfirmModal(false)}>Annuler</button>
                <button onClick={confirmReservation}>Confirmer</button>
              </div>
            </div>
          </div>
        )}

        <img src={logo_close} alt="Fermer" onClick={() => onCancel()} className="kdo-logoclose" />
        <h3>{readonly ? "Detail de l'article" : "Editer l'article"}</h3>
        <div>
          {localObj.imagelink && (
            <img src={localObj.imagelink} 
                  alt="Apercu" 
                  style={{ maxHeight: "150px", maxWidth: "150px", borderRadius: "10px" }}                  
                  onClick={() => p_setLightboxImg(object?.imagelink)} />
          )}
          <div>
            <label>
              Liste : {!localObj.idList && <span style={{ color: "red", marginLeft: "10px" }}>* Veuillez choisir une liste</span>}
            </label>
            <ListSelector
              className="ov-listselector"
              userKey={AuthServices.getConnectedKey()}
              p_idList={localObj.idList}
              onSelect={(idList) => {
                setLocalObj((prev) => ({ ...prev, idList }));
              }}
              disabled={readonly}
            />

            <label>Titre :</label>
                        <input name="title" value={localObj.title} onChange={handleChange} disabled={readonly}/>

                        <label>Url de l'image :</label>
                        <input name="imagelink" value={localObj.imagelink} onChange={handleChange} disabled={readonly}/>

                        <label>Description :</label>
                        <textarea name="description" value={localObj.description} onChange={handleChange} disabled={readonly}/>

                        <label>Prix :</label>
                        <input name="price" type="number" value={localObj.price} onChange={handleChange} disabled={readonly}/>

                        <label>Site / Boutique :</label>
                        <input name="site" value={localObj.site} onChange={handleChange} disabled={readonly}/>

                        <label>URL :</label>
                        <input name="url" value={localObj.url} onChange={handleChange} disabled={readonly}/>

                        {isReserved && (
                        <>
                        <div className="ov-reserved-banner" role="status" aria-live="polite">
                            <span className="ov-reserved-icon" aria-hidden>⚠️</span>
                            <span className="ov-reserved-text">Cet article est déjà réservé</span>
                          {!readonly && <div className="ov-reserver-details-trigger">
                            <button type="button" onClick={handleShowReserver} disabled={isLoadingReserver}>
                              {showReserver ? "Masquer" : "Voir qui a réservé"}
                            </button>
                          </div>}
                        </div>
                          {showReserver && (
                            <div className="ov-reserver-details" role="note">
                              {isLoadingReserver && <span>Chargement…</span>}
                              {!isLoadingReserver && reserverError && <span>{reserverError}</span>}
                              {!isLoadingReserver && !reserverError && reserverInfo && (
                                <span>Réservé par: {reserverInfo.name} ({reserverInfo.email!= "me@me.com" && reserverInfo.email})</span>
                              )}
                            </div>
                          )}
                        </>
            )}

            <div className="ui-buttons">
              <button onClick={onCancel}>Annuler</button>
              {!readonly && (
                <>
                  <button
                    onClick={handleAutoComplete}
                    disabled={isCompleting || !localObj?.url || !hasEmptyFields || isReserved}
                    title="Completer automatiquement les champs vides depuis l'URL"
                  >
                    {isCompleting ? "Completion..." : "Completer automatiquement"}
                  </button>
                  <button onClick={handleSave} disabled={!localObj.idList || isDaataRegistering}>Enregistrer</button>
                  {localObj?.id ? (
                    <button onClick={handleReserve} disabled={localObj.reservationid || isDaataRegistering} title="Réserver cet article à mon nom">
                      {localObj?.reservationid ? "Réservé !" : "Réserver"}
                    </button>
                  ) : null}
                </>
              )}
            </div>

            {completeMsg && <div className="ui-info">{completeMsg}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ObjectEditor;

